export enum EXP_TYPE_ENUM {
  BASE = 0,
  EXP1 = 1,
  EXP2 = 2,
}
